export const normalizeProductDefinitionId = (value: unknown): string | undefined => {
  if (Array.isArray(value)) {
    const firstValue = value[0]
    return typeof firstValue === 'string' && firstValue ? firstValue : undefined
  }

  if (typeof value === 'string' && value) {
    return value
  }

  return undefined
}
